// extracted by mini-css-extract-plugin
export default {"popover":"PopoverTile_popover__VfI0D","card":"PopoverTile_card__WyWwV"};